var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"class-schedule"},[_c('ed-class-schedule',{attrs:{"schedule":_vm.schedule},on:{"onBack":_vm.returnToAdmin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }